import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const EducationDefaultSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.98114 10.9734V15.4326C4.98114 16.2087 5.43136 16.9144 6.13521 17.2415L11.1219 19.5588C11.6549 19.8065 12.2701 19.8065 12.8031 19.5588L17.7898 17.2415C18.4937 16.9144 18.9439 16.2087 18.9439 15.4326V14.2121C18.9439 13.8985 18.6578 13.6627 18.35 13.7226L11.9789 14.9628L4.98114 10.9734Z"
      fill="#D7E0EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2975 1.38462C12.8632 1.14409 12.3378 1.13472 11.8952 1.3596L1.10854 6.83963C-0.154401 7.48125 -0.124637 9.29548 1.15868 9.89532L12 14.9628L22.9793 9.83081C24.2373 9.24281 24.2978 7.47628 23.083 6.80356L13.2975 1.38462Z"
      fill="#D7E0EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1839 22.2742C19.0672 22.5991 19.3079 22.9415 19.6532 22.9415H23.2247C23.5691 22.9415 23.8098 22.6006 23.6946 22.276L21.9196 17.2759C21.7628 16.8344 21.1388 16.8332 20.9803 17.2742L19.1839 22.2742Z"
      fill="#D7E0EE"
    />
    <path
      d="M21.4375 12.8944V18.546"
      stroke="#D7E0EE"
      strokeWidth="1.49601"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgWrapper>
)
